import { PageController } from '@client/components/_core/layout/PageController';
import { DocumentSourceConnectionsList } from '@client/components/document-sources/DocumentSourceConnectionsList';
import { ORG_ROLES } from '@shared/constants/business/user';
import { PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { FolderSearch } from 'lucide-react';

/**
 * Document sources (CUR-2565): the Microsoft 365 tenancies an organisation has connected so
 * auditors can find documents for compliance audits. The add form and each connection's set-up
 * checklist are URL drawers under this page.
 */
export const Route = createFileRoute('/console/$orgId/configuration/api-integrations/document-sources')({
    staticData: {
        presentation: 'page',
        breadcrumb: { title: 'Document sources' },
        ui: {
            icon: FolderSearch,
            title: 'Document sources',
            subtitle:
                'Connect authorised representatives’ Microsoft 365 so auditors can find documents for compliance audits',
            menuDescription:
                'Connect authorised representatives’ Microsoft 365 so auditors can find documents for compliance audits.',
        },
        // The server also needs `enable-compliance-audit`, which a route cannot add as a second flag;
        // the document sources flag is only switched on where compliance audits are.
        featureFlag: 'enable-audit-document-sources',
        modules: ['compliance-audit'],
        // The server gate needs `compliance_audit:manage` AND `settings:update`. A route's
        // `permissions` list is OR, so the settings half is carried by the role: `org_admin` is the
        // only organisation role holding `settings:update` (as on Compliance audit configuration).
        roles: [ORG_ROLES.ORG_ADMIN],
        permissions: [PERMISSIONS.COMPLIANCE_AUDIT_MANAGE],
    },
    component: DocumentSourcesPage,
});

function DocumentSourcesPage() {
    return (
        <PageController route={Route}>
            <DocumentSourceConnectionsList />
            <Outlet />
        </PageController>
    );
}
